import axios from "axios";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { config } from "../../../ConfigFile/Config";

const Appointment = () => {
  const baseUrl = config.baseUrl;
  const [appointment, setAppointment] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100;
  const [searchValue, setSearchValueserach] = useState("");
  const [uniqueCount, setUniqueCount] = useState(0);
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });

  const getAppointment = async () => {
    try {
      const token = localStorage.getItem("token");
      const { startDate, endDate } = dateRange;
      let query = "";
      if (startDate && endDate) {
        query = `?startDate=${startDate}&endDate=${endDate}`;
      }
      const { data } = await axios({
        url: `${baseUrl}/api/website/user/get-appointment-details${query}`,
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      });
      setUniqueCount(data.uniqueCount);
      const sortedData = data.bookingData
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map((item, index) => ({
          ...item,
          uniqueId: 1 + index,
        }));
      setAppointment(sortedData);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching appointments:", error);
      toast.error("Failed to fetch appointments");
    }
  };

  const exportToExcel = () => {
    if (!dateRange?.startDate && !dateRange?.endDate && !searchValue?.trim()) {
      toast.error(
        "Please select start date and end date OR enter search value"
      );
      return;
    }

    if (!appointment.length) {
      toast.error("No Data Found");
      return;
    }
    const exportData = filteredItems.map((item) => ({
      ID: item.uniqueId,
      Name: item.name,
      Mobile: item.mobile,
      Email: item.email,
      Role: item.roleType,
      City: item.city,
      State: item.state || "-",
      services: item.services,
      UTMSource: item.UTMSource || "N/A",
      UTMMedium: item.UTMMedium || "N/A",
      UTMCampaign: item.UTMCampaign || "N/A",
      UTMContent: item.UTMContent || "N/A",
      UTMTerm: item.UTMTerm || "N/A",
      Created_At: item.createdAt
        ? new Date(item.createdAt).toLocaleString("en-GB", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          })
        : "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "appointment");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, "appointment.xlsx");
  };

  useEffect(() => {
    getAppointment();
  }, [dateRange]);

  const handleChange = (e) => {
    setDateRange({
      ...dateRange,
      [e.target.name]: e.target.value,
    });
  };
  const formChangeSerach = (e) => {
    setSearchValueserach(e.target.value);
    setCurrentPage(1);
  };

  const filteredItems = appointment.filter(
    (item) =>
      (item.name &&
        item.name.toLowerCase().includes(searchValue.toLowerCase())) ||
      (item.uniqueId && item.uniqueId.toString().includes(searchValue))
  );
  console.log("filteredItems", filteredItems)
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));
  };

  return (
    <div className="container-fluid w-100 p-0">
      <ToastContainer />
      <div className="d-flex align-items-center mb-4 gap-3">
        <div className="w-50">
          <h4>Book Appointment Applications</h4>
        </div>
        <div className="d-flex w-50 gap-3">
          <div className="w-100">
            <div className="form-group">
              <label className="fw-bold">Search by Name</label>
              <input
                onChange={formChangeSerach}
                value={searchValue}
                type="text"
                placeholder="Search by Name"
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="d-flex w-50 gap-3">
          <div className="w-100">
            <label className="fw-bold">Start Date</label>
            <input
              type="date"
              className="form-control"
              name="startDate"
              value={dateRange.startDate}
              onChange={handleChange}
            />
          </div>
          <div className="w-100">
            <label className="fw-bold">End Date</label>
            <input
              type="date"
              className="form-control"
              name="endDate"
              value={dateRange.endDate}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="mt-4 mx-3">
          <button className="btn btn-success fw-bold" onClick={exportToExcel}>
            Export
          </button>
        </div>
      </div>

      <div
        className="table-responsive"
        style={{ overflowY: "scroll", height: "58vh" }}
      >
        <table className="table table-bordered table-hover align-middle">
          <thead
            className="table-dark"
            style={{ position: "sticky", top: "0" }}
          >
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>City</th>
              <th>State</th>
              <th>Services</th>
              <th>UTMSource</th>
              <th>UTMMedium</th>
              <th>Create Date</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr key={item.id}>
                <td>{item.uniqueId}</td>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.mobile}</td>
                <td>{item.city}</td>
                <td>{item.state || "N/A"}</td>
                <td>{item.services}</td>
                <td>{item.UTMSource || "N/A"}</td>
                <td>{item.UTMMedium || "N/A"}</td>
                <td>
                  {item.createdAt
                    ? new Date(item.createdAt).toLocaleString("en-GB", {
                        timeZone: "Asia/Kolkata",
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                      })
                    : "N/A"}
                </td>
              </tr>
            ))}
            {currentItems.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {filteredItems.length > itemsPerPage && (
        <div className="d-flex justify-content-between align-items-center bg-dark text-white p-2 mt-2">
          <button
            className="btn btn-primary"
            onClick={handlePrev}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <div style={{ textAlign: "center" }}>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <br />
            <span>
              Showing {currentItems.length} out of {filteredItems.length}{" "}
              entries
            </span>
            <p>Unique Count: {uniqueCount}</p>
          </div>
          <button
            className="btn btn-primary"
            onClick={handleNext}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Appointment;
